import React from 'react';
import { SvgIcon } from '@mui/material';

export function ReactFragmentIcon({ sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 24, height: 24, ...sx }}
      {...props}
    >
      <g filter="url(#a)">
        <rect width="24" height="24" rx="4" fill="#9786FF" fillOpacity=".22" />
        <g opacity=".8" filter="url(#b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m4.547 12.304.44-.249-.44-.248v.497Z"
            fill="#9483FF"
          />
          <path
            d="M4.547 12.304v-.498l.44.25.968-.547 4.489-2.536v-1.59l-7.659 4.328v.69l7.659 4.326v-1.589l-5.457-3.083-.44.25Z"
            fill="#9483FF"
          />
          <path
            d="m2.785 11.71 7.659-4.326.488-.99-6.894 3.942-1.253 1.375Zm8.147 2.63-4.977-2.831-.968.546 5.457 3.083.488-.799Z"
            fill="#AFA2FF"
          />
          <path
            d="M10.444 7.384v1.589l.488-1.092V6.395l-.488.989Zm0 7.754v1.59l.488-.765v-1.624l-.488.8Z"
            fill="#8470FF"
          />
        </g>
        <g opacity=".8" filter="url(#c)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m19.452 12.304-.44-.249.44-.248v.497Z"
            fill="#9483FF"
          />
          <path
            d="M19.452 12.304v-.498l-.44.25-.968-.547-4.49-2.536v-1.59l7.66 4.328v.69l-7.66 4.326v-1.589l5.458-3.083.44.25Z"
            fill="#9483FF"
          />
          <path
            d="m21.214 11.71-7.66-4.326-.488-.99 6.894 3.942 1.254 1.375Zm-8.148 2.63 4.978-2.831.968.546-5.457 3.083-.489-.799Z"
            fill="#AFA2FF"
          />
          <path
            d="M13.555 7.384v1.589l-.489-1.092V6.395l.489.989Zm0 7.754v1.59l-.489-.765v-1.624l.489.8Z"
            fill="#8470FF"
          />
        </g>
      </g>
      <defs>
        <filter
          id="a"
          x="-10.061"
          y="-10.061"
          width="44.122"
          height="44.122"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.031" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_12064_59537"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_12064_59537"
            result="shape"
          />
        </filter>
        <filter
          id="b"
          x="1.44"
          y="6.395"
          width="10.839"
          height="13.022"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.345" />
          <feGaussianBlur stdDeviation=".673" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.402167 0 0 0 0 0.120833 0 0 0 0 1 0 0 0 0.35 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12064_59537"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_12064_59537"
            result="shape"
          />
        </filter>
        <filter
          id="c"
          x="11.721"
          y="6.395"
          width="10.839"
          height="13.022"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.345" />
          <feGaussianBlur stdDeviation=".673" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.402167 0 0 0 0 0.120833 0 0 0 0 1 0 0 0 0.35 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12064_59537"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_12064_59537"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
